import { TranscriptParticipant } from '../model/transcript-participant.model';
import { Transcript } from '../model/transcript.model';

export function transcriptParticipants(
    transcript?: Transcript,
): TranscriptParticipant[] {
    const participants: TranscriptParticipant[] = [];
    if (transcript?.organizer != null) {
        participants.push(transcript.organizer);
    }
    if (transcript?.attendees != null) {
        participants.push(...transcript.attendees);
    }
    return participants;
}

export function transcriptParticipantStrings(
    transcript?: Transcript,
): string[] {
    const participants: string[] = [];
    if (
        transcript?.organizer?.speaker != null &&
        transcript.organizer.speaker.trim().length > 0
    ) {
        participants.push(transcript.organizer.speaker);
    }
    if (transcript?.attendees != null) {
        transcript.attendees?.forEach((e) => {
            if (e.speaker != null && e.speaker.trim().length > 0) {
                participants.push(e.speaker);
            }
        });
    }
    return participants;
}
